import React, { useEffect, useRef, useState } from "react";
import "./BusinessOneCounter.scss";

const countersData = [
  { value: 12, label: "Helpful Staff" },
  { value: 10, label: "Years Of Experience" },
  { value: 200, label: "Happy Customers" },
  { value: 30, label: "Customer Services" },
];

const BusinessOneCounter = () => {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // true when entering viewport, false when leaving
        setInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="business_one_counter" ref={sectionRef}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="counter_left">
              <div className="counter_card">
                {countersData.map((item, idx) => (
                  <CounterBox key={idx} value={item.value} label={item.label} inView={inView} />
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="counter_right">
              <h4 className="line_title">
                <span></span>
                Explore More
              </h4>
              <div className="video_parent">
                <video
                  src="assets/video/dummy_video.mp4"
                  autoPlay
                  muted
                  controls
                  loop
                ></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CounterBox = ({ value, label, inView }) => {
  const [count, setCount] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    // stop & reset when not in view
    if (!inView) {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      setCount(0);
      return;
    }

    let startTs = null;
    const duration = 1500; // ms

    const tick = (ts) => {
      if (!startTs) startTs = ts;
      const progress = Math.min((ts - startTs) / duration, 1);
      setCount(Math.floor(progress * value));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [inView, value]);

  return (
    <div className="counter_single">
      <div className="cs_inner">
        <h5>{count}+</h5>
        <div className="wave">
          <span className="material-symbols-outlined">water</span>
        </div>
        <h6>{label}</h6>
      </div>
    </div>
  );
};

export default BusinessOneCounter;
